const helpres = {
  methods: {
    getStatus ({ status }) {
      const humanStatuses = {
        draft: 'Черновик',
        under_moderation: 'На модерации',
        declined: 'Отклонено',
        passed: 'Одобрено',
        in_progress: 'В работе',
        pending: 'Ожидание',
        paused: 'Приостановлено',
        completed: 'Завершено',
        archived: 'Архив',
        error: 'Ошибка',
        viewed: 'Просмотрено',
        responded: 'Есть ответ',
        sent: 'Отправлено'
      }

      return humanStatuses[status] || status
    },
    getStatusColor ({ status }) {
      const colors = {
        draft: 'dark',
        under_moderation: 'warning',
        declined: 'danger',
        passed: 'success',
        in_progress: 'success',
        pending: 'light',
        paused: 'secondary',
        completed: 'success',
        archived: 'dark',
        viewed: 'success',
        responded: 'success',
        error: 'danger',
        sent: 'primary'
      }

      return colors[status] || 'primary'
    }
  }
}

export default helpres
